import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {

    retrieveUsers({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("user/retrieveUsers").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveUsersBySearch({ commit }, filter) {
        commit("SET_LOADING", true);
        return getAPI("user/retrieveUsersBySearch" , filter)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveUserById({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("user/retrieveUserById" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      saveUser({ commit }, user) {
        commit("SET_LOADING", true);
        return postAPI("user/saveUser", user).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteUser({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("user/deleteUser/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveProfiles({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("user/retrieveProfiles").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      countUsers({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("user/count").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };